import React, { useEffect } from 'react';
import { SectionServices } from '../layout/SectionServices';
import { SectionContact } from '../layout/SectionContact';
import { SectionNewDevelopment } from '../layout/SectionNewDevelopment';
import { useQuery } from '@apollo/client';
import { useParams, useRouteMatch } from 'react-router';
import { SectionInfoNarrow } from '../layout/SectionInfoNarrow';
import { Overlap } from '../layout/Overlap';
import { Page } from '../layout/Page';
import { Seo } from '../../utils/seo/Index';
import { StatusWrapper } from '../layout/StatusWrapper';
import { SectionNewsCard } from '../layout/SectionNewsCard';
import { ImageCarousel } from '../layout/carousel/ImageCarousel_v2';
import { Query, QueryGetPageContentInputArgs } from '../../../client/types/generated/types';
import { PageContentType } from '../../../server/global/enum';
import { useState } from 'react';

//GraphQL
import { CONTENT_ITEM } from '../../../client/__graphql__/queries/page_content/getPageContent';

type GetPageItem = Pick<Query, 'getNdPageContent'>;
type GetPageItemVariables = QueryGetPageContentInputArgs;

const Office: React.FC = () => {
  const params = useParams<{ urltag: string }>();

  const { data, loading } = useQuery<GetPageItem, GetPageItemVariables>(CONTENT_ITEM, {
    fetchPolicy: 'network-only',
    variables: {
      input: { urltag: params.urltag, type: PageContentType.FRONTPAGE }
    }
  });

  if (loading) {
    return null;
  }

  // `PrivatMegleren - Nordeas Eiendomsmeglerkjede`

  return (
    <>
      <Seo
        title={`PrivatMegleren ${data?.getNdPageContent?.office?.name}`}
        image={data?.getNdPageContent?.seo?.image ? data?.getNdPageContent?.seo?.image : undefined}
        description={data?.getNdPageContent?.seo?.text ? data?.getNdPageContent?.seo?.text : undefined}
      />
      <Page>
        <ImageCarousel
          url={data?.getNdPageContent?.image}
          imageList={data?.getNdPageContent?.imageList}
          title={data?.getNdPageContent?.title}
          get_properties={true}
        />
        <Overlap yPos={-70} yPos2={-20}>
          <SectionInfoNarrow info={data?.getNdPageContent?.text} hidedivider classNameInfo={'center'} />
        </Overlap>
        {data?.getNdPageContent?.config?.showStatistics ? <StatusWrapper /> : null}
        {data?.getNdPageContent?.config?.showFrontpageNews ? <SectionNewsCard /> : null}
        {data?.getNdPageContent?.config?.showFrontpageService ? <SectionServices style={{ marginTop: '2em' }} /> : null}
        <SectionNewDevelopment
          showProperties={data?.getNdPageContent?.config?.showSubpageProperties == true}
          showHighlighedProperty={data?.getNdPageContent?.config?.showSubpagePropertiesHighlight == true}
          showTitle
        />
      </Page>
    </>
  );
};

export default Office;
